import { datadogRum } from '@datadog/browser-rum';

import { APP_ENVS, currentAppEnvironment } from '@savgroup-front-common/constants';
import { getDatadogRumBaseConfig } from '@savgroup-front-common/core/services';

datadogRum.init({
  ...getDatadogRumBaseConfig(),
  service: 'revers-front-backoffice',
  sessionReplaySampleRate: currentAppEnvironment === APP_ENVS.PROD ? 5 : 0,
  allowedTracingUrls: [
    'https://dev-api.revers.io',
    'https://demo-api.revers.io',
    'https://api.revers.io',
    'https://*.preview.revers.io',
    /^https:\/\/[^/]+\.preview.revers\.io/,
  ],
});

datadogRum.startSessionReplayRecording();
